<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { ref } from "vue";
import Loading from 'vue-loading-overlay';
import Multiselect from '@vueform/multiselect';
import { useForm, Link } from '@inertiajs/vue3';

const props = defineProps({
    year: String,
    roles: Object,
    flash: Object,
    allPermissions: Object,
    user: Object,
});
let isLoading = ref(false);
const options = props.allPermissions;

const RoleAddform = useForm({
    modalRoleName: '',
    permissions: [],
});

const RoleAddformSubmit = () => {
    RoleAddform.post('/roles/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
};

</script>
<style scoped>
@import "/public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "@vueform/multiselect/themes/default.css";
</style>
<template>
    <AppLayout title="Roles Manager" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <h4 class="fw-bold py-3 mb-2">Roles List</h4>
            <p>
                A role provided access to predefined menus and features so that depending on <br>
                assigned role an administrator can have access to what user needs.
            </p>

            <div class="row g-4">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="role in roles" :key="role.id">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between mb-2">
                                <!-- <h6 class="fw-normal">4 Permissions</h6> -->
                            </div>
                            <div class="d-flex justify-content-between align-items-end">
                                <div class="role-heading">
                                    <h4 class="mb-1">{{ role.name }}</h4>
                                    <Link href="javascript:;" data-bs-toggle="modal" data-bs-target="#addRoleModal"
                                        class="role-edit-modal"><small>Edit Role</small>
                                    </Link>

                                </div>
                                <Link href="javascript:;" data-bs-toggle="modal" data-bs-target="#addRoleModal"
                                    class="btn btn-outline-danger"><small>Remove
                                    Role</small>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="card h-100">
                        <div class="row h-100">
                            <div class="col-sm-5">
                                <div class="d-flex align-items-end h-100 justify-content-center mt-sm-0 mt-3">
                                    <img src="/ui/img/illustrations/sitting-girl-with-laptop-light.png"
                                        class="img-fluid" alt="Image" width="120"
                                        data-app-light-img="illustrations/sitting-girl-with-laptop-light.png"
                                        data-app-dark-img="illustrations/sitting-girl-with-laptop-dark.png">
                                </div>
                            </div>
                            <div class="col-sm-7" v-if="$page.props.user.permissions.includes('add-roles')">
                                <div class="card-body text-sm-end text-center ps-sm-0">
                                    <button data-bs-target="#addRoleModal" data-bs-toggle="modal"
                                        class="btn btn-primary mb-3 text-nowrap add-new-role">
                                        Add New Role
                                    </button>
                                    <p class="mb-0">Add role, if it does not exist</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="addRoleModal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-simple modal-dialog-centered modal-add-new-role">
                    <div class="modal-content p-3 p-md-5">
                        <div class="modal-body">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="text-center mb-4">
                                <h3 class="role-title">Add New Role</h3>
                                <p>Set role permissions</p>
                            </div>
                            <!-- Add role form -->
                            <form class="row g-2" @submit.prevent="RoleAddformSubmit">
                                <div class="col-12 mb-4">
                                    <label class="form-label" for="modalRoleName">Role Name</label>
                                    <input type="text" v-model="RoleAddform.modalRoleName" name="modalRoleName"
                                        class="form-control" placeholder="Enter a role name" tabindex="-1" />
                                </div>
                                <div class="col-12">
                                    <label class="form-label" for="modalRoleName">Role Permissions</label>
                                    <Multiselect v-model="RoleAddform.permissions" :options="options" mode="tags"
                                        :closeOnSelect="false" :searchable=true placeholder="Select permission ..."
                                        track-by="name" label="name" :object="true" :required=true />
                                </div>
                                <div class="col-12 text-center">
                                    <button type="submit" class="btn btn-primary me-sm-3 me-1">Submit</button>
                                    <button type="reset" class="btn btn-label-secondary" data-bs-dismiss="modal"
                                        aria-label="Close">
                                        Cancel
                                    </button>
                                </div>
                            </form>
                            <!--/ Add role form -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>